import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackForwardCacheService {
  private detector: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public detector$ = this.detector.asObservable();

  public emitBackForwardCacheDetection() {
    this.detector.next(true);
  }
}
